import { useEffect, useState } from 'react';
import { Input, Select } from 'antd';
import { ColumnFilterActions } from '@/components/DataTable/ColumnFilterPanel';
import { type OrderFilterKey, type OrderFilterPatch } from './filters';

interface SearchPanelProps {
  filterKey: OrderFilterKey;
  value: string;
  placeholder: string;
  onApply: (patch: OrderFilterPatch) => void;
  close: () => void;
}

export function SearchFilterPanel({ filterKey, value, placeholder, onApply, close }: SearchPanelProps) {
  const [text, setText] = useState(value);
  useEffect(() => setText(value), [value]);

  const apply = (next: string) => {
    onApply({ [filterKey]: next.trim() });
    close();
  };

  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Input
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onPressEnter={() => apply(text)}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <ColumnFilterActions onSearch={() => apply(text)} onReset={() => apply('')} />
    </div>
  );
}

interface SelectPanelProps {
  filterKey: OrderFilterKey;
  value: string;
  options: { label: string; value: string }[];
  onApply: (patch: OrderFilterPatch) => void;
  close: () => void;
}

export function SelectFilterPanel({ filterKey, value, options, onApply, close }: SelectPanelProps) {
  const [selected, setSelected] = useState(value);
  useEffect(() => setSelected(value), [value]);

  const apply = (next: string) => {
    onApply({ [filterKey]: next });
    close();
  };

  return (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <Select
        style={{ width: 180, marginBottom: 8, display: 'block' }}
        placeholder="Chọn..."
        value={selected || undefined}
        onChange={(val) => setSelected(val ?? '')}
        options={options}
        allowClear
      />
      <ColumnFilterActions onSearch={() => apply(selected)} onReset={() => apply('')} />
    </div>
  );
}
